import MasterUploader from "@/components/MasterUploader";
export default function Entities() {
  return (
    <MasterUploader
      kind="entities"
      title="Entities"
      subtitle="Master list of schools / entities that offer programs."
      columns={[
        { key: "entity_id", label: "Entity ID", mono: true },
        { key: "entity_name", label: "Entity Name" },
      ]}
      templateHint="entity_id, entity_name"
    />
  );
}
